import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

/**
 * LoadingIndicator component with semantic styling
 * Displays a simple loading message with optional animation
 */
const LoadingIndicator = ({ message = 'Loading...', className = '' }) => {
  const colors = useColors();
  const semantic = colors.semantic;
  const { replace } = useTextReplacement();

  return (
    <div className={`flex items-center justify-center py-8 ${className}`}>
      <div className={`${semantic.loadingText} animate-pulse`}>
        {replace(message)}
      </div>
    </div>
  );
};

LoadingIndicator.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string
};

export default LoadingIndicator;

